<template>
  <div class="kt-wrapper">
    <slot></slot>
    <!-- footer -->
    <div class="footer">
      <div class="footer-inner">
        <div class="footer-left">
          <a
            :href="link.SiteUrl"
            target="_blank"
            v-for="link in links"
            :key="link.SiteName"
            class="ve-link"
            >{{ link.SiteName }}</a
          >
        </div>
        <div class="footer-right">
          <h3 class="footer-logo">高等教育出版社</h3>
          <div class="footer-text">
            <p>
              <a
                href="https://www.icve.com.cn/portal_new/apply/apply.html"
                target="_blank"
                class="ve-link"
                >开通项目申请表</a
              >&nbsp;|&nbsp;

              <a
                href="https://www.icve.com.cn/portal_new/platform/platform.html?page=1"
                target="_blank"
                class="ve-link"
                >平台简介</a
              >&nbsp;|&nbsp;

              <a
                href="https://www.icve.com.cn/portal_new/platform/platform.html?page=2"
                target="_blank"
                class="ve-link"
                >知识产权</a
              >&nbsp;|&nbsp;

              <a
                href="https://www.icve.com.cn/portal_new/platform/platform.html?page=3"
                target="_blank"
                class="ve-link"
                >免责声明</a
              >&nbsp;|&nbsp;

              <a
                href="https://www.icve.com.cn/portal_new/platform/platform.html?page=4"
                target="_blank"
                class="ve-link"
                >意见反馈</a
              >&nbsp;|&nbsp;

              <a
                href="https://www.icve.com.cn/portal_new/platform/platform.html?page=5"
                target="_blank"
                class="ve-link"
                >联系我们</a
              >&nbsp;|&nbsp;

              <a
                href="https://www.icve.com.cn/portal_new/platform/platform.html?page=6"
                target="_blank"
                class="ve-link"
                >积分说明</a
              >&nbsp;|&nbsp;

              <a
                href="https://www.icve.com.cn/portal_new/platform/policy.html"
                target="_blank"
                class="ve-link"
                >隐私政策</a
              >
              <a
                href="https://help.icve.com.cn/jjxx"
                target="_blank"
                class="ve-link"
                >疫情防控在线教学方案</a
              >
            </p>
          </div>
        </div>
        <div class="footer-copyright">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202007836"
          >
            <p>
              京公网安备 11010202007836号
            </p>
          </a>
          <span>Copyright©2014-2019 高等教育出版社</span>
          <a href="http://beian.miit.gov.cn" class="copyright-ICP"
            >京ICP备12020869号-19</a
          >
          <div style="display: inline-block;vertical-align: middle;">
            <span>技术支持:</span>
            <a href="javascript:;"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 获取教育部友情链接的接口
const FriendLink = "https://www.icve.com.cn/common/common/getFriendLink";

export default {
  data() {
    return {
      links: [
        {
          SiteUrl: "http://www.moe.gov.cn/",
          SiteName: "中华人民共和国教育部",
          SortOrder: 1
        },
        {
          SiteUrl: "http://www.hep.com.cn/",
          SiteName: "高等教育出版社",
          SortOrder: 2
        },
        {
          SiteUrl: "http://www.tech.net.cn/",
          SiteName: "中国高职高专教育网",
          SortOrder: 3
        },
        {
          SiteUrl: "http://www.landraco.com/",
          SiteName: "高教社网上书城",
          SortOrder: 4
        },
        {
          SiteUrl: "http://www.enetedu.com/",
          SiteName: "全国高校教师网络培训中心",
          SortOrder: 5
        },
        {
          SiteUrl: "https://weidian.com/s/899960007?wfr=c&ifr=shopdetail",
          SiteName: "高教社官方微店",
          SortOrder: 6
        },
        {
          SiteUrl: "http://www.univs.cn/",
          SiteName: "中国大学生在线",
          SortOrder: 7
        },
        {
          SiteUrl: "http://hebei.icve.com.cn/",
          SiteName: "河北省职教云平台",
          SortOrder: 8
        },
        {
          SiteUrl: "http://zhejiang.icve.com.cn/",
          SiteName: "浙江省教学能力比赛平台",
          SortOrder: 9
        },
        {
          SiteUrl: "http://guizhou.icve.com.cn/",
          SiteName: "贵州省教学能力比赛平台",
          SortOrder: 10
        },
        {
          SiteUrl: "http://sc.icve.com.cn/",
          SiteName: "四川省教学能力比赛平台",
          SortOrder: 11
        },
        {
          SiteUrl: "http://nmg.icve.com.cn/",
          SiteName: "内蒙古教学能力比赛平台",
          SortOrder: 12
        }
      ]
    };
  },
  mounted() {
    this.GetFriendLink();
  },
  methods: {
    GetFriendLink() {
      this.$http.get(FriendLink).then(data => {
        this.links = data.list;
      });
    }
  }
};
</script>
